import styled from '@emotion/styled';
import FONT from '../../../../styles/emotion/fonts';
import MEDIA_QUERY from '../../../../styles/emotion/mediaQuery';
import COLORS, { COLORS_SEMANTIC } from '../../../../styles/emotion/colors3';

const squareSize = '24px';

const getLabelTextColor = (disabled?: boolean, checked?: boolean): string => {
  if (disabled) {
    return COLORS.BLACK_030;
  }

  if (checked) {
    return COLORS.BLACK_100;
  }

  return COLORS.BLACK_100;
};

const getFieldWrapperBackgroundColor = (disabled?: boolean, selectorStyle?: boolean): string => {
  if (disabled && selectorStyle) {
    return COLORS.BLACK_005;
  }
  if (selectorStyle) {
    return COLORS.WHITE_100;
  }
  return 'inherit';
};

const getFieldWrapperBorderColor = (
  checked?: boolean,
  disabled?: boolean,
  error?: boolean,
  selectorStyle?: boolean
): string => {
  if (error && selectorStyle) {
    return COLORS_SEMANTIC.NEGATIVE_100;
  }
  if (checked && selectorStyle) {
    return COLORS.BLACK_100;
  }
  if (disabled && selectorStyle) {
    return COLORS.BLACK_030;
  }
  if (selectorStyle) {
    return COLORS.BLACK_015;
  }
  return 'inherit';
};

const getFieldWrapperHoverBorderColor = (
  checked?: boolean,
  disabled?: boolean,
  error?: boolean,
  selectorStyle?: boolean
): string => {
  if (error && selectorStyle) {
    return COLORS_SEMANTIC.NEGATIVE_100;
  }
  if (checked && selectorStyle) {
    return COLORS.BLACK_100;
  }
  if (disabled && selectorStyle) {
    return COLORS.BLACK_030;
  }
  if (selectorStyle) {
    return COLORS.BLACK_030;
  }
  return 'inherit';
};

const getRadioHoverBorderColor = (disabled?: boolean, error?: boolean): string => {
  if (error) {
    return COLORS_SEMANTIC.NEGATIVE_100;
  }
  if (disabled) {
    return COLORS.BLACK_030;
  }
  return COLORS.BLACK_050;
};

const getRadioBorderColor = (checked?: boolean, error?: boolean, disabled?: boolean): string => {
  if (error) {
    return COLORS_SEMANTIC.NEGATIVE_100;
  }
  if (disabled) {
    return COLORS.BLACK_030;
  }
  if (checked) {
    return COLORS.BLACK_100;
  }
  return COLORS.BLACK_030;
};

const getCheckedRadioBorderColor = (error?: boolean, disabled?: boolean): string => {
  if (error) {
    return COLORS_SEMANTIC.NEGATIVE_100;
  }
  if (disabled) {
    return COLORS.BLACK_015;
  }

  return COLORS.BLACK_100;
};

const getRadioBackgroundColor = (
  checked?: boolean,
  disabled?: boolean,
  error?: boolean,
  selectorStyle?: boolean
): string => {
  if (disabled && selectorStyle) {
    return COLORS.BLACK_005;
  }
  if (disabled || error) {
    return COLORS.WHITE_100;
  }
  if (checked) {
    return COLORS.BLACK_100;
  }

  return COLORS.WHITE_100;
};

const getRadioHoverBackgroundColor = (
  checked?: boolean,
  disabled?: boolean,
  error?: boolean,
  selectorStyle?: boolean
): string => {
  if (disabled && selectorStyle) {
    return COLORS.BLACK_005;
  }
  if (disabled) {
    return COLORS.WHITE_100;
  }
  if (error) {
    return COLORS_SEMANTIC.NEGATIVE_030;
  }
  if (checked) {
    return COLORS.BLACK_100;
  }

  return COLORS.BLACK_030;
};

const getCheckedRadioBackgroundColor = (
  disabled?: boolean,
  error?: boolean,
  selectorStyle?: boolean
): string => {
  if ((disabled && selectorStyle) || error) {
    return COLORS.BLACK_030;
  }
  if (disabled) {
    return COLORS.BLACK_030;
  }

  return COLORS.BLACK_100;
};

export const MessageWrapper = styled.div`
  margin-top: 4px;
`;

export const RadioField = styled.div<{
  disabled?: boolean;
  selectorStyle?: boolean;
}>`
  margin: ${(props) => (props.selectorStyle ? '0' : '8px 0')};
  color: ${(props) => (props.disabled ? COLORS.BLACK_015 : COLORS.BLACK_100)};
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  font-weight: ${FONT.FONT_WEIGHT_REGULAR}};

  &:hover {
    background: ${(props) => (props.selectorStyle ? 'transparent' : 'transparent')};
  }

  ${MEDIA_QUERY.MOBILE} {
    margin: ${(props) => (props.selectorStyle ? '0' : '12px 0 12px 20px')};
  }
`;

export const StyledLabel = styled.label<{
  disabled?: boolean;
  error?: boolean;
  checked?: boolean;
  selectorStyle?: boolean;
}>`
  display: flex;
  position: relative;
  padding: ${(props) => (props.selectorStyle ? '20px' : '0')};

  &::before {
    content: '';
    position: relative;
    top: -1px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${squareSize};
    min-width: ${squareSize};
    height: ${squareSize};
    margin-right: 8px;
    border-radius: 4px;
    vertical-align: middle;
    .transition(0.3s);
    border-radius: 50%;

    border: 1px solid ${(props) => getRadioBorderColor(props.checked, props.error, props.disabled)};
    background-color: ${(props) =>
      getRadioBackgroundColor(props.checked, props.disabled, props.error, props.selectorStyle)};
    box-shadow: ${(props) => (props.disabled ? 'none' : `inset 0 0 0 5px ${COLORS.WHITE_100}`)};
    

    ${MEDIA_QUERY.MOBILE} {
      margin-right: 12px;
    }
  }
  &:hover::before {
    background-color: ${(props) =>
      getRadioHoverBackgroundColor(
        props.checked,
        props.disabled,
        props.error,
        props.selectorStyle
      )};
    border: 1px solid ${(props) => (props.error ? COLORS_SEMANTIC.NEGATIVE_100 : COLORS.BLACK_100)};
  }

  &::after {
    margin: ${(props) => (props.selectorStyle ? '20px 0' : '0')}
  }
`;

export const SelectorLabelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  width: 100%;
  color: ${COLORS.BLACK_100};
`;

export const SelectorLabel = styled.span<{ disabled?: boolean; checked?: boolean }>`
  font-weight: ${(props) => (props.checked ? FONT.FONT_WEIGHT_REGULAR : FONT.FONT_WEIGHT_REGULAR)};
  color: ${(props) => getLabelTextColor(props.disabled, props.checked)};
`;

export const ToolTipWrapper = styled.span`
  position: relative;
  vertical-align: middle;
  margin-left: 5px;

  svg {
    color: ${COLORS.BLACK_100};
    position: relative;
    top: 1px;
    left: 1px;
  }
  .tooltip__container {
    position: absolute;
    bottom: calc(100% + 9px);
    left: 50%;
    transform: translate(-50%, 0);
  }
`;

export const Dek = styled.p<{ disabled?: boolean; selectorStyle?: boolean }>`
  color: ${(props) => (props.disabled ? COLORS.BLACK_015 : COLORS.BLACK_050)};
  font-size: ${FONT.FONT_SIZE_SMALLER};
  margin: 0;
  margin-top: ${(props) => (props.selectorStyle ? '4px' : '0')};
`;

export const SelectorLabelRight = styled.span<{ disabled?: boolean }>`
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  height: 28px;
  text-align: right;
  color: ${(props) => (props.disabled ? COLORS.BLACK_015 : COLORS.BLACK_050)};
  margin-left: 40px;
  white-space: nowrap;

  ${MEDIA_QUERY.MOBILE} {
    margin-left: 12px;
  }
`;

export const StyledExpandedArea = styled.div`
  background: ${COLORS.BLACK_005};
  padding: 20px;
  border-top: 1px solid ${COLORS.BLACK_050};

  ${MEDIA_QUERY.DESKTOP} {
    padding: 32px 52px 40px 52px;
  }
`;

export const StyledInput = styled.input<{
  error?: boolean;
  selectorStyle?: boolean;
  checked?: boolean;
  disabled?: boolean;
}>`
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  &:focus-visible + label::before {
    outline: 5px auto Highlight;
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: 2px;
  }
  &:checked + label::after {
    border: 1px solid ${(props) => getCheckedRadioBorderColor(props.error, props.disabled)};
    background: ${(props) =>
      getCheckedRadioBackgroundColor(props.disabled, props.error, props.selectorStyle)};
    content: '';
    position: absolute;
    top: -1px;
    align-items: center;
    justify-content: center;
    width: ${squareSize};
    min-width: ${squareSize};
    height: ${squareSize};
    margin-right: 8px;
    vertical-align: middle;
    border-radius: 50%;
    box-shadow: ${(props) =>
      props.disabled
        ? `inset 0 0 0 5px ${COLORS.WHITE_100}`
        : `inset 0 0 0 5px ${COLORS.WHITE_100}`};

    &:hover {
      border-color: ${(props) => getRadioHoverBorderColor(props.disabled, props.error)};
    }
  }
`;

export const RadioFieldWrapper = styled.div<{
  error?: boolean;
  selectorStyle?: boolean;
  checked?: boolean;
  disabled?: boolean;
  inline?: boolean;
}>`
  font-family: ${FONT.FONT_FAMILY_CIRCULAR};
  font-size: ${FONT.FONT_SIZE_SMALL};
  line-height: normal; // ?
  color: ${COLORS.BLACK_100};
  background: ${(props) =>
    props.disabled || props.selectorStyle
      ? getFieldWrapperBackgroundColor(props.disabled, props.selectorStyle)
      : null};

  display: ${(props) => (props.inline ? 'inline-block' : 'block')};
  border: ${(props) =>
    props.selectorStyle || props.checked
      ? `1px solid ${getFieldWrapperBorderColor(
          props.checked,
          props.disabled,
          props.error,
          props.selectorStyle
        )}`
      : 'none'};
  border-radius: ${(props) => (props.selectorStyle ? `4px` : '0')};
  margin-bottom: ${(props) => (props.selectorStyle ? '12px' : '0')};

  &:hover {
    background: ${(props) => (props.selectorStyle ? '' : 'inherit')};
    border: ${(props) =>
      props.selectorStyle || props.checked
        ? `1px solid ${getFieldWrapperHoverBorderColor(
            props.checked,
            props.disabled,
            props.error,
            props.selectorStyle
          )}`
        : 'none'};
    ${StyledLabel} {
      cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
      &::before {
        border-color: ${(props) => getRadioHoverBorderColor(props.disabled, props.error)};
      }
    }
    ${SelectorLabel} {
      color: ${(props) => (props.disabled ? COLORS.BLACK_030 : COLORS.BLACK_100)};
    }
    ${SelectorLabelRight} {
      color: ${(props) => (props.disabled ? COLORS.BLACK_030 : COLORS.BLACK_100)};
    }
  }
`;
